import { render } from "./PaymentReceiptDetailTabHistory.vue?vue&type=template&id=f2059a38"
import script from "./PaymentReceiptDetailTabHistory.vue?vue&type=script&lang=js"
export * from "./PaymentReceiptDetailTabHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__